import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Admin } from '../interfaces/admin.type';

export const homeAuthGuardGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthenticationService);

  const currentUser: Admin =
    JSON.parse(localStorage.getItem('currentUser')) ?? undefined;

  const decode = (token: string): any => {
    if (currentUser) return JSON.parse(atob(token.split('.')[1]));
  };

  if (currentUser) {
    const expirationTime = decode(currentUser?.accessToken).exp * 1000;
    const currentTime = Date.now();
    const expirationThreshold = expirationTime - 20 * 60 * 1000;
    const isExpired = currentTime > expirationThreshold;
    
    if (!isExpired) {
      router.navigate(['/dashboard/']);
      return false;
    } else {
      auth.logout();
      return true;
    }
  } else {
    return true;
  }
};
